/**
 * Expose raw http://dexie.org constructor
 *
 * # Documentation
 * Documentation can be found at http://dexie.org/docs
 */
export const DexieProvider = {
  provide: 'Dexie',
  useValue: require('dexie').default,
};
